module.exports = __webpack_public_path__ + "img/tether.eac1f7bb.svg";